// extracted by mini-css-extract-plugin
export default {"contenedor":"styles_contenedor__uZ3rU","buttonContainer":"styles_buttonContainer__erVbw","texto":"styles_texto__lQyqi"};